export default __webpack_public_path__ + "static/media/cu.0a499324.svg";